import {attach, combine, guard, sample} from 'effector';
import i18next from 'i18next';

import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';

import {fetchDataFx} from 'models/documents/documents/grid/table';
import {DocumentsGridRawRowExtended} from 'types/invoices';

import {errorHandlerNoFirs} from '../create/helpers/errorHandlerNoFirs';

import {
    CreateInvoiceGate,
    fetchOptionFx,
    fetchCompanyNameFx,
    fetchTaxCategodyFx,
    fetchPaymentMeansFx,
    $invoiceState,
    deleteInvoiceFx,
    $invoiceStatusInfo,
    updateInvoiceStatusFx,
    setNewInvoiceIsDone,
    $newInvoiceIsDone,
    $invoicesFilters,
    fetchInvoicesFilters,
    // fetchInvoicesFiltersFx,
} from './index';

deleteInvoiceFx.fail.watch(({error}) => showRestError(error as RestError));

deleteInvoiceFx.done.watch((data) => {
    console.log(data);
    const {reportId} = data.result.data;
    toast.success(i18next.t('pages.documents.form.documentRemoved', {reportId}), {
        className: 'Toastify__toast__wide',
    });
});

$invoicesFilters.on(fetchInvoicesFilters, (_, data) => data);

const singleInvoiceFetchDataFx = attach({
    effect: fetchDataFx,
    mapParams: () => ({
        sortings: [{id: 'createdAt', desc: true}],
        filters: [],
        paging: {
            pageNumber: 0,
            pageSize: 3,
        },
        search: $invoiceState.getState() ?? '',
        updOnly: true,
    }),
});

guard({
    clock: $invoiceState,
    filter: (i: string | null) => !!i && i !== 'new',
    target: singleInvoiceFetchDataFx,
});

sample({
    clock: CreateInvoiceGate.open,
    target: [fetchOptionFx, fetchCompanyNameFx, fetchTaxCategodyFx, fetchPaymentMeansFx],
});

updateInvoiceStatusFx.fail.watch(({error}) => {
    errorHandlerNoFirs(error);
    return showRestError(error as RestError);
});

updateInvoiceStatusFx.done.watch((reportId) => {
    toast.success(i18next.t('pages.documents.invoices.statusChanged', {reportId}), {
        className: 'Toastify__toast__wide',
    });
});

$newInvoiceIsDone.on(setNewInvoiceIsDone, (_, data) => data);

sample({
    clock: updateInvoiceStatusFx.doneData,
    fn: () => true,
    target: setNewInvoiceIsDone,
});

export const $doesInvoiceExist = sample({
    clock: $invoiceState,
    fn: (id) => {
        if (id === null || (typeof id === 'string' && id === 'new')) {
            return false;
        }
        return true;
    },
});

$invoiceStatusInfo
    .on(singleInvoiceFetchDataFx.doneData, (_, data) => {
        const {side, status} = data.content[0] as DocumentsGridRawRowExtended;
        return {
            side,
            status,
        };
    })
    .reset(CreateInvoiceGate.close);
